import { gql } from "@apollo/client";

export const FETCH_PRODUCTS = gql`
    query Products {
        products {
            name
            description
            productId
            prices {
                priceId
                amount
                currency
                interval
                seatType
            }
        }
    }
`;
